import r from"antd/lib/upload";var a=r.Dragger,o=r;export{o as Uploader,a as UploaderDragger};
